import React from "react";
import { Link } from "react-router-dom";

const AboutContentTwo = () => {
  return (
    <div className="how__work__about">
      {/* <div className="container">
        <div className="row">
          <div className="col-lg-6 col-md-12 col-sm-12 col-12 sm__mt--40 md__mt--40 black-heading">
            <div className="content-left">
              <img src="/images/about/doublecot.png" />
              <h2>
                At The Pips, we believe that trading isn’t just about numbers,
                it’s about knowledge, confidence, and growth.
              </h2>
              <p>
                XYZ, <br></br>Founder and CEO
              </p>
            </div>
          </div>

          <div className="col-lg-6 col-md-12 col-sm-12 col-12 ">
            <div className="thumb-right">
              <img
                src={
                  process.env.PUBLIC_URL + "/images/contents/Illustration_2.jpg"
                }
                alt="computer images"
              />
            </div>
          </div>
        </div>
      </div> */}
      {/* <div className="container"> */}
      <div className="ceo-quote-container-about">
        {/* Left Column: Image */}

        {/* Right Column: Content */}
        <div className="ceo-content-wrapper-about">
          <div className="ceo-content-inner-about">
            {/* Yellow Quote Icon */}
            <div className="quote-icon-about">
              <svg
                width="40"
                height="40"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M10 11L8 11C8.55 8.5 9.9 7.75 11 7.5V5.5C8 6 6 8.5 6 11V17H11V11ZM18 11L16 11C16.55 8.5 17.9 7.75 19 7.5V5.5C16 6 14 8.5 14 11V17H19V11Z"
                  fill="#012d65"
                />
              </svg>
            </div>

            {/* Quote Text */}
            <h2 className="quote-text-about">
              At The Pips, we believe that trading isn’t just about numbers,
              it’s about knowledge, confidence, and growth.
            </h2>

            {/* Author Details */}
            <div className="quote-author-about">
              <h5 className="author-name-about">XYZ,</h5>
              <p className="author-title-about">Founder and CEO</p>
            </div>
          </div>
        </div>
        <div className="ceo-image-wrapper-about">
          <img
            src={
              process.env.PUBLIC_URL +
              "/images/company/about_us/about_us_2.png"
            }
            alt="Petr Valov, Founder and CEO"
            className="ceo-image-about"
            onError={(e) => {
              e.target.onerror = null;
              e.target.style.display = "none";
              e.target.parentNode.style.backgroundColor = "#333"; // Fallback if image missing
            }}
          />
        </div>
      </div>
      {/* </div> */}
    </div>
  );
};

export default AboutContentTwo;
